// extracted by mini-css-extract-plugin
export default {"container":"aPiKlArG","backButtonContainer":"IuMDVUI8","backButton":"DbZGrwlM"};